import PropTypes from 'prop-types';
import React from 'react';
import Media from 'react-media';
import { connect } from 'react-redux';
import Drawer from '../../../components/layout/drawer/Drawer';
import { isAuthorized } from '../../../modules/user/selectors';
import SideNav from '../SideNav';

export const DefaultView = ({ children, authorized }) => (
  <div className="default-view">
    <div className="default-view-main">{children}</div>
    {authorized && (
      <Media query={{ minWidth: 966 }}>
        {matches => (
          matches ? (
            <div className="default-view-aside">
              <SideNav />
            </div>
          ) : (
            <Drawer name="nav">
              <SideNav />
            </Drawer>
          )
        )}
      </Media>
    )}
  </div>
);

DefaultView.propTypes = {
  children: PropTypes.node,
  authorized: PropTypes.bool.isRequired
};

const DefaultViewConnect = connect(state => ({
  authorized: isAuthorized(state)
}))(DefaultView);

export const defaultLayout = Component => () => (
  <DefaultViewConnect>
    <Component />
  </DefaultViewConnect>
);

export default DefaultViewConnect;
